import ResetPassword from "components/ResetPassword/ResetPassword";
import React from "react";

const PasswordReset = () => {
  return <ResetPassword />;
};

export default PasswordReset;
